(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aura-choose-energy"] && !Shopify.designMode) return;
  try {
    
  /* Parallax vertical du fond au scroll, repris de w-choose-energy.js (Pléiades) : amplitude réduite à 50 px */
  (function () {
    if (customElements.get('choose-energy-parallax')) return;
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    class ChooseEnergyParallax extends HTMLElement {
      connectedCallback() {
        if (REDUCED) return;
        this._ticking = false;
        this._update = this.update.bind(this);
        this._onScroll = () => {
          if (this._ticking) return;
          this._ticking = true;
          window.requestAnimationFrame(() => { this._ticking = false; this._update(); });
        };
        window.addEventListener('scroll', this._onScroll, { passive: true });
        document.addEventListener('scroll', this._onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this._onScroll);
        window.addEventListener('load', this._onScroll);
        this._update();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        document.removeEventListener('scroll', this._onScroll, { capture: true });
        window.removeEventListener('resize', this._onScroll);
        window.removeEventListener('load', this._onScroll);
      }
      update() {
        var range = 50;
        var rect = this.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        if (rect.bottom < 0 || rect.top > vh) return;
        var progress = (vh / 2 - (rect.top + rect.height / 2)) / (vh / 2 + rect.height / 2);
        progress = Math.max(-1, Math.min(1, progress));
        this.style.setProperty('--ce-scroll', (progress * range).toFixed(1) + 'px');
      }
    }
    customElements.define('choose-energy-parallax', ChooseEnergyParallax);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-founder-story"] && !Shopify.designMode) return;
  try {
    
  /* Modale "Read more" du bloc Emma Zepter (reprise de story-modal.js de Pléiades) */
  (function () {
    if (window.__auraStoryModalInit) return;
    window.__auraStoryModalInit = true;

    function open(modal) {
      modal.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      var close = modal.querySelector('[data-story-close]');
      if (close) close.focus();
    }
    function close(modal) {
      modal.hidden = true;
      document.documentElement.style.overflow = '';
    }

    document.addEventListener('click', function (e) {
      var openBtn = e.target.closest('[data-story-open]');
      if (openBtn) {
        var wrap = openBtn.closest('.afs__readmore-wrap') || document;
        var modal = wrap.querySelector('[data-story-modal]');
        if (modal) open(modal);
        return;
      }
      var closeEl = e.target.closest('[data-story-close]');
      if (closeEl) {
        var m = closeEl.closest('[data-story-modal]');
        if (m) close(m);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        document.querySelectorAll('[data-story-modal]:not([hidden])').forEach(close);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-key-notes"] && !Shopify.designMode) return;
  try {
    
  /* Déclenche l'animation quand le milieu de la section croise le milieu de l'écran (logique Pléiades) */
  (function () {
    if (customElements.get('key-notes')) return;

    class KeyNotes extends HTMLElement {
      connectedCallback() {
        this._check = this.check.bind(this);
        window.addEventListener('scroll', this._check, { passive: true });
        document.addEventListener('scroll', this._check, { passive: true, capture: true });
        window.addEventListener('resize', this._check);
        window.addEventListener('load', this._check);
        this._check();
      }
      disconnectedCallback() {
        window.removeEventListener('scroll', this._check);
        document.removeEventListener('scroll', this._check, { capture: true });
        window.removeEventListener('resize', this._check);
        window.removeEventListener('load', this._check);
      }
      check() {
        if (this.classList.contains('is-active')) return;
        var rect = this.getBoundingClientRect();
        var wh = window.innerHeight || document.documentElement.clientHeight;
        if (rect.top <= wh / 2 && rect.bottom >= wh / 2) this.classList.add('is-active');
      }
    }

    customElements.define('key-notes', KeyNotes);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["aura-story-chapter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* Fondu au scroll des chapitres */
    function initReveal(root) {
      if (REDUCED || !('IntersectionObserver' in window)) return;
      var els = (root || document).querySelectorAll('.aura-chapter .ch-reveal:not([data-ch-init])');
      if (!els.length) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.remove('is-pending'); io.unobserve(e.target); }
        });
      }, { threshold: 0.15 });
      els.forEach(function (el) {
        el.setAttribute('data-ch-init', '');
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) return; /* déjà visible : pas d'animation */
        el.classList.add('is-pending');
        io.observe(el);
      });
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initReveal(); });
    else initReveal();
    document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); });

    /* Pierres qui défilent : même calcul et même comportement que le bloc de la page d'accueil
       ((hauteur fenêtre - top) x 0.35), sans élément personnalisé et sans coupure en mode « réduire les animations »,
       exactement comme le bloc de la home. Un seul écouteur global pour toutes les bandes de la page. */
    if (!window.__auraStoryRocksInit) {
      window.__auraStoryRocksInit = true;
      var tick = false;
      /* Mesure l'écart entre la bande et la photo du chapitre, gap et marges compris, pour la coller à la photo.
         Photo à gauche : la bande s'étire vers la gauche. Photo à droite : vers la droite.
         Photo au-dessus (mobile) : la bande annule le padding de la colonne, comme le bloc de la home. */
      var measure = function () {
        document.querySelectorAll('.aura-chapter .ch__rocks').forEach(function (strip) {
          strip.style.setProperty('--rock-bleed-left', '0px');
          strip.style.setProperty('--rock-bleed-right', '0px');
          var section = strip.closest('.aura-chapter');
          var photo = section && section.querySelector('.ch__ph');
          var s = strip.getBoundingClientRect();
          var left = 0, right = 0;
          if (photo) {
            var p = photo.getBoundingClientRect();
            var sideBySide = p.bottom > s.top - 2000 && p.top < s.bottom + 2000 && (p.right <= s.left + 1 || p.left >= s.right - 1);
            if (sideBySide && p.right <= s.left + 1) left = s.left - p.right;
            else if (sideBySide && p.left >= s.right - 1) right = p.left - s.right;
          }
          if (!left && !right) {
            var split = strip.closest('.ch__split');
            if (split) left = parseFloat(getComputedStyle(split).paddingLeft) || 0;
          }
          strip.style.setProperty('--rock-bleed-left', Math.max(0, left).toFixed(1) + 'px');
          strip.style.setProperty('--rock-bleed-right', Math.max(0, right).toFixed(1) + 'px');
        });
      };
      var update = function () {
        tick = false;
        var wh = window.innerHeight;
        document.querySelectorAll('.aura-chapter .ch__rocks').forEach(function (strip) {
          var r = strip.getBoundingClientRect();
          if (r.bottom < 0 || r.top > wh) return;
          var track = strip.querySelector('.ch__rocks-track');
          if (track) track.style.transform = 'translateX(-' + ((wh - r.top) * 0.35).toFixed(1) + 'px)';
        });
      };
      var onScroll = function () { if (!tick) { tick = true; requestAnimationFrame(update); } };
      window.addEventListener('scroll', onScroll, { passive: true });
      document.addEventListener('scroll', onScroll, { passive: true, capture: true });
      var remeasure = function () { measure(); onScroll(); };
      window.addEventListener('resize', remeasure);
      window.addEventListener('load', remeasure);
      document.addEventListener('DOMContentLoaded', remeasure);
      document.addEventListener('shopify:section:load', remeasure);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(remeasure);
      remeasure();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-image-scroll"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (customElements.get('image-text-scroll')) return;

    class ImageTextScroll extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('.faq-item-text').forEach((panel) => {
          panel.style.overflow = 'hidden';
          panel.style.maxHeight = '0px';
          panel.dataset.open = 'false';
        });
        this._update = this.update.bind(this);
        this._ticking = false;
        this._onScroll = () => {
          if (this._ticking) return;
          this._ticking = true;
          window.requestAnimationFrame(() => { this._ticking = false; this._update(); });
        };
        // window + capture sur document : couvre aussi un thème qui scrolle dans un conteneur interne
        window.addEventListener('scroll', this._onScroll, { passive: true });
        document.addEventListener('scroll', this._onScroll, { passive: true, capture: true });
        window.addEventListener('resize', this._onScroll);
        window.addEventListener('load', this._onScroll);
        if (document.fonts && document.fonts.ready) document.fonts.ready.then(this._onScroll);
        this._update();
        setTimeout(this._update, 300);
      }

      disconnectedCallback() {
        window.removeEventListener('scroll', this._onScroll);
        document.removeEventListener('scroll', this._onScroll, { capture: true });
        window.removeEventListener('resize', this._onScroll);
        window.removeEventListener('load', this._onScroll);
      }

      openPanel(panel) {
        if (panel.dataset.open !== 'true') panel.dataset.open = 'true';
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }

      closePanel(panel) {
        panel.style.maxHeight = '0px';
        panel.dataset.open = 'false';
      }

      // Tout est calculé en coordonnées viewport (pas de scrollY) : robuste quel que soit le conteneur de scroll.
      update() {
        const items = Array.from(this.querySelectorAll('.image-text-scroll__items:not([hidden]) .image-text-scroll__item'));
        if (!items.length) return;
        const vh = window.innerHeight;
        const tops = items.map((el) => el.getBoundingClientRect().top);

        const pcts = items.map((_, i) => {
          let pct;
          if (i === 0) {
            pct = (vh * 0.75 - tops[0]) / (vh * 0.25);
          } else {
            const span = tops[i] - tops[i - 1];
            pct = span > 0 ? (vh * 0.5 - tops[i - 1]) / span : (tops[i - 1] <= vh * 0.5 ? 1 : 0);
          }
          return Math.max(0, Math.min(1, pct));
        });

        items.forEach((item, i) => {
          const badge = item.querySelector('.image-text-scroll__item-span');
          const fill = item.querySelector('.scroll__effect .content');
          const panel = item.querySelector('.faq-item-text');
          const active = i === 0 ? pcts[0] > 0 : pcts[i - 1] >= 1;

          if (badge) badge.classList.toggle('active', active);
          item.classList.toggle('is-active', active);
          if (panel) active ? this.openPanel(panel) : this.closePanel(panel);
          if (fill) fill.style.height = (pcts[i] * 100) + '%';
        });
      }
    }

    customElements.define('image-text-scroll', ImageTextScroll);
  })();

  } catch(e) { console.error(e); }
})();
})();
